import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Stack, Tooltip, Typography } from "@mui/material";
import { prettyPrintDateMed } from "util/dates";

import { getOverdueTooltip } from "./statusStyles";

type TaskDeadlineProps = {
  deadline: string;
  overdue: boolean;
  /** Smaller, secondary text beneath the date (e.g. "Recurring"). */
  subtitle?: string;
};

/** A task's deadline as the task list shows it: overdue dates in red italics with an icon. */
export function TaskDeadline({ deadline, overdue, subtitle }: TaskDeadlineProps) {
  return (
    <Stack alignItems="start" sx={{ minWidth: 0 }}>
      <Stack direction="row" alignItems="center" gap={0.5} sx={{ minWidth: 0 }}>
        {overdue && (
          <Tooltip title={getOverdueTooltip(deadline)} arrow>
            <ErrorOutlineIcon sx={{ fontSize: 16, flexShrink: 0 }} color="error" />
          </Tooltip>
        )}
        <Typography
          variant="body2"
          color={overdue ? "error" : undefined}
          fontStyle={overdue ? "italic" : undefined}
        >
          {prettyPrintDateMed(deadline)}
        </Typography>
      </Stack>
      {subtitle && (
        <Typography variant="caption" color="text.secondary">
          {subtitle}
        </Typography>
      )}
    </Stack>
  );
}
